export default
{
  OwnersManagements: [],
  OwnersManagement: {},
  search:{},
}
